__turbopack_context__.v({
  "close-dialog": "styles-module-scss-module__ql3h5a__close-dialog",
  "full-size": "styles-module-scss-module__ql3h5a__full-size",
  "gallery-divider": "styles-module-scss-module__ql3h5a__gallery-divider",
});
